import React from "react";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

const DISCLAIMER = `Teuralink is a private commemorative registry offering symbolic Moon and Mars-themed gift experiences. All certificates, registry entries, maps, and related products are commemorative novelty items intended for gifting, collecting, entertainment, and personal enjoyment. They do not confer legal ownership, property rights, government-recognized title, or any legally enforceable interest in land on the Moon, Mars, or any other celestial body. All registry records are maintained exclusively within the Private Teuralink Commemorative Registry.`;

export default function Legal() {
  return (
    <div className="pt-28 pb-24 px-6 lg:px-10 relative z-10">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="overline text-white/50 hover:text-white">← Back to Home</Link>
        <div className="overline text-gold mt-8">Legal · Disclaimer</div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight mt-2">
          A Commemorative Registry, Not a Legal Deed.
        </h1>

        <div className="mt-10 glass rounded-3xl p-8 lg:p-10 space-y-6 text-white/80 leading-relaxed">
          <div className="flex gap-4 p-5 border border-amber-500/25 rounded-2xl bg-amber-500/5">
            <AlertTriangle className="w-5 h-5 text-amber-300 shrink-0 mt-1" />
            <p data-testid="legal-disclaimer">{DISCLAIMER}</p>
          </div>

          <div>
            <div className="overline mb-2">What You Receive</div>
            <ul className="list-disc list-outside pl-5 space-y-1.5 marker:text-gold">
              <li>A unique Teuralink Plot Registration Number.</li>
              <li>A premium printed commemorative deed, hand-finished and shipped to you.</li>
              <li>A public verification page that confirms your registration.</li>
              <li>Access to your dashboard with courier tracking.</li>
            </ul>
          </div>

          <div>
            <div className="overline mb-2">What You Do Not Receive</div>
            <ul className="list-disc list-outside pl-5 space-y-1.5 marker:text-gold">
              <li>Any legal ownership, title, or rights to land on the Moon or Mars.</li>
              <li>Any tax, financial, or investment instrument.</li>
              <li>Rights recognized under international law or by any government.</li>
            </ul>
          </div>

          <div className="grid sm:grid-cols-3 gap-3 pt-2">
            <Link to="/privacy" className="btn-ghost justify-center">Privacy Policy</Link>
            <Link to="/terms" className="btn-ghost justify-center">Terms &amp; Conditions</Link>
            <Link to="/refund" className="btn-ghost justify-center">Refund Policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
